exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_title_3T8NHRDvEiSQOCDozfIYaf {\n  color: \"#333333\";\n  font-size: 24px;\n  font-weight: 100;\n  margin-bottom: 10px;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  box-orient: vertical;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: lighter;\n  display: -webkit-box;\n  margin-top: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_title": "IA_title_3T8NHRDvEiSQOCDozfIYaf"
};